import React from "react";
import ReactDOM from "react-dom/client";
import { LangProvider } from "./i18n";
import { App } from "./App";
import "./styles.css";
import { initSentry } from "@cafe-os/observability";

// Sentry error monitoring.
initSentry({ app: "landing" });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </React.StrictMode>,
);
